<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom: 32px">
      <router-link
        class="button is-medium is-light"
        :to="{ name: 'configurations.documentcreate' }"
      >
        <span class="icon is-small">
          <span class="material-icons">add_circle_outline</span>
        </span>
        <span>Crear</span>
      </router-link>
    </div>
    <div>
      <p class="title">{{ title }}</p>
      <div class="table-container">
        <table class="table is-hoverable is-narrow is-fullwidth">
          <thead>
            <tr>
              <th>Código</th>
              <th>Nombre</th>
              <th>Consecutivo</th>
              <th>Tipo</th>
              <th>Electrónico</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(comprobante, index) in comprobantes" :key="index">
              <td>
                <strong>{{ comprobante.codigo }}</strong>
              </td>
              <td>{{ comprobante.nombre }}</td>
              <td>{{ comprobante.consecutivo }}</td>
              <td>{{ comprobante.estructura }}</td>
              <td>
                <div v-show="comprobante.isElectronico" class="control">
                  <div class="tags has-addons">
                    <span class="tag is-dark">Electrónico</span>
                    <span v-if="comprobante.isPrueba" class="tag is-warning"
                      >Pruebas</span
                    >
                    <span v-if="!comprobante.isPrueba" class="tag is-link"
                      >Producción</span
                    >
                  </div>
                </div>
              </td>
              <td>
                <router-link
                  tag="span"
                  :to="{
                    name: 'configurations.documentedit',
                    params: { id: comprobante._id },
                  }"
                  class="material-icons has-text-link hand"
                  >edit</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      title: "Documentos",
      comprobantes: [],
    };
  },
  computed: {
    ...mapState(["empresa"]),
  },
  methods: {
    async findComprobantes() {
      try {
        const result = await apiServices.get(`/comprobantes`);
        this.comprobantes = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findComprobantes();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/document/Document.vue